import StatisticTablePage from '@/pages/StatisticTablePage/StatisticTablePage.vue'

export default StatisticTablePage
